<template>
  <div id="indexlayout-right-top" :class="{ enableTopNav: false }">
    <div class="indexlayout-right-top-top" :style="{ background: menuBg }">
      <div
        class="indexlayout-flexible"
        :class="{ active: isCollapse }"
        @click="toggleSideBar"
      >
        <svg-icon icon-class="s-fold" :style="{ color: textColor }" />
      </div>
      <div class="indexlayout-top-menu">
        <el-scrollbar class="horizontal-scrollbar">
          <template v-if="siteTopNavEnable">
            <template v-for="route in permission_routes">
              <app-link
                class="indexlayout-top-menu-li"
                v-if="!route.hidden"
                :to="route.path"
                :key="route.path"
                :class="{ active: getTopMenuActive === route.path }"
              >
                {{ route.meta.title }}
              </app-link>
            </template>
          </template>
          <!-- <breadcrumb v-else class="breadcrumb" /> -->
        </el-scrollbar>
      </div>
      <div class="indexlayout-top-menu-right">
        <el-dropdown
          v-if="hasMultiCompany"
          placement="bottom-start"
          trigger="click"
          @command="switchCompany"
        >
          <span class="el-dropdown-link" :style="{ color: textColor }">
            <span class="el-dropdown-link-text">{{ company.title }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in companies"
              :key="item.id"
              :command="item.id"
              :class="{ actived: +item.id === +companyId }"
            >
              {{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <span v-else class="top-menu-right-item">{{ company.title }}</span>

        <span :style="{ color: textColor, userSelect: 'none' }">欢迎，</span>
        <el-dropdown>
          <span
            class="el-dropdown-link"
            :title="username"
            :style="{ color: textColor }"
          >
            <span class="el-dropdown-link-text">{{ username }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="goInfo">
              个人信息
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout">
              退出
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import AppLink from '@/components/Link'
// import Breadcrumb from '@/components/Breadcrumb'
import { getBelongTopMenuPath } from '@/utlis/permission'
export default {
  name: 'LayoutIndexRightTop',
  components: {
    AppLink
    // Breadcrumb
  },
  data() {
    return {
      companies: []
    }
  },
  computed: {
    menuBg() {
      return this.$store.state.theme.menuBg
    },
    textColor() {
      return this.$store.state.theme.color
    },
    isCollapse() {
      return !this.sidebarOpened
    },
    getTopMenuActive() {
      let route = this.$route
      return getBelongTopMenuPath(route)
    },
    hasMultiCompany() {
      return this.companies.length > 1
    },
    company() {
      if (!this.companies[0]) return {}
      return this.companies.length === 1
        ? this.companies[0]
        : this.companies.find(c => +c.id === +this.companyId)
    }
  },
  mounted() {
    this.companies = this.$store.getters.companies
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      try {
        const { isExternal, siteLoginRouter } = await this.$store.dispatch(
          'user/logout'
        )
        if (!isExternal) {
          this.$router.push(
            siteLoginRouter + '?redirect=' + this.$route.fullPath
          )
        }
      } catch (error) {
        this.$message.error(error || 'Has Error')
      }
    },
    switchCompany(companyId) {
      if (+companyId !== +this.companyId) {
        this.$store.dispatch('user/setCompanyId', companyId)
        window.location.reload()
      }
    },
    goInfo() {
      this.$router.push('/me')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/variables.scss';
#indexlayout-right-top {
  width: 100%;
  height: ($headerHeight + $headerBreadcrumbHeight);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  z-index: 9;
  .indexlayout-right-top-top {
    display: flex;
    width: 100%;
    height: $headerHeight;
    // background-color: $leftBgColor;
    color: $topMenuFontColor;
    .indexlayout-flexible,
    .indexlayout-top-menu-right,
    .indexlayout-top-menu {
      height: $headerHeight;
      line-height: $headerHeight;
    }
    .indexlayout-flexible {
      width: $headerHeight;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: $topMenuHoverBgColor;
        color: $topMenuHoverFontColor;
      }
      &.active {
        svg {
          transform: rotate(180deg);
        }
      }
    }
    .indexlayout-top-menu-right {
      min-width: 145px;
      padding-right: 1rem;
      .index-layout-message {
        display: inline-block;
        margin-right: 10px;
        color: $topMenuHoverFontColor;
        .index-layout-message-item {
          /deep/ .el-badge__content {
            border: none;
          }
        }
      }
      .top-menu-right-item,
      .el-dropdown {
        margin-right: 1rem;
      }
      .el-dropdown-link {
        display: inline-block;
        cursor: pointer;
        color: $topMenuHoverFontColor;
        .el-dropdown-link-text {
          font-size: 1rem;
          display: block;
          // max-width: 56px;
          height: $headerHeight;
          overflow: hidden;
          float: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          word-break: break-all;
        }
      }
    }
    .indexlayout-top-menu {
      flex: 1;
      display: flex;
      overflow: hidden;
      /* overflow-x: auto; */
      .indexlayout-top-menu-li {
        display: inline-block;
        padding: 0 15px;
        height: ($headerHeight)-6;
        text-decoration: none;
        color: $topMenuFontColor;
        font-size: 15px;
        border-bottom: solid 5px transparent;
        &:hover,
        &.active {
          background-color: $topMenuHoverBgColor;
          color: $topMenuHoverFontColor;
          border-bottom-color: $leftMenuActiveBgColor;
        }
        &.active {
          background-color: $topMenuActiveBgColor;
        }
      }
      .breadcrumb {
        line-height: $headerHeight;
        margin-left: 10px;
        .el-breadcrumb__item {
          display: inline-block;
          float: none;
        }
      }
    }
  }
  .indexlayout-right-top-bot {
    display: flex;
    width: 100%;
    height: $headerBreadcrumbHeight;
    background-color: $mainBgColor;
    .indexlayout-right-top-bot-home {
      margin-right: 5px;
      width: $headerBreadcrumbHeight;
      height: $headerBreadcrumbHeight;
      line-height: $headerBreadcrumbHeight;
      text-align: center;
    }
    .breadcrumb {
      line-height: $headerBreadcrumbHeight;
    }
  }
  &.enableTopNav {
    height: $headerHeight;
    .indexlayout-right-top-top {
      background-color: $BreadcrumbBgColor;
      color: $BreadcrumbFontColor;

      .indexlayout-flexible {
        &:hover {
          background-color: $mainBgColor;
          color: $BreadcrumbFontColor;
        }
      }
    }
    .indexlayout-top-menu-right {
      .index-layout-message {
        color: $BreadcrumbFontColor;
      }
      .el-dropdown-link {
        color: $BreadcrumbFontColor;
      }
    }
  }
}
</style>

<style media="screen">
#indexlayout-right-top .el-dropdown {
  user-select: none;
}
</style>
